module.exports = __webpack_public_path__ + "img/galeria_mobile.7adf8b78.jpg";